import { render, staticRenderFns } from "./ProductRows.vue?vue&type=template&id=40136e50&scoped=true&"
import script from "./ProductRows.vue?vue&type=script&lang=js&"
export * from "./ProductRows.vue?vue&type=script&lang=js&"
import style0 from "./ProductRows.vue?vue&type=style&index=0&id=40136e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40136e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40136e50')) {
      api.createRecord('40136e50', component.options)
    } else {
      api.reload('40136e50', component.options)
    }
    module.hot.accept("./ProductRows.vue?vue&type=template&id=40136e50&scoped=true&", function () {
      api.rerender('40136e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ProductRows.vue"
export default component.exports